export const owlCarouselOptions = {
  loop: true,
  margin: 10,
  nav: true,
  items: 4,
  slideBy: 1,
  responsive: {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 4 },
  },
};